import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "group", "item", "noResults"]

  connect() {
    this.itemsByGroup = this.groupTargets.map((group) => ({
      group,
      items: this.itemTargets.filter((item) => group.contains(item))
    }))
  }

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()

    this.itemTargets.forEach((item) => {
      const matches = query === "" || item.dataset.search.includes(query)
      item.classList.toggle("hidden", !matches)
    })

    let anyGroupVisible = false
    const hiddenGroupIds = []
    this.itemsByGroup.forEach(({ group, items }) => {
      const hasVisibleItem = items.some((item) => !item.classList.contains("hidden"))
      group.classList.toggle("hidden", !hasVisibleItem)
      anyGroupVisible ||= hasVisibleItem
      if (!hasVisibleItem) hiddenGroupIds.push(group.id)
    })

    this.noResultsTarget.classList.toggle("hidden", anyGroupVisible)
    this.dispatch("filtered", { detail: { hiddenGroupIds } })
  }
}
